<template>
    <div>
        <div class="flex items-center">
            <h3 class="card-header">Lista de Sindicatos</h3>
            <download-csv :data="sindicatosLista">
                <svg-icon
                    icon="excel"
                    class="icon-excel cursor-pointer"
                ></svg-icon>
            </download-csv>
        </div>
        <vue-good-table
            @on-page-change="onPageChange"
            @on-sort-change="onSortChange"
            @on-per-page-change="onPerPageChange"
            ref="vue-good-table"
            :columns="sindicatos.columns"
            :rows="sindicatos.rows"
            :totalRows="sindicatos.total"
            :responsive="true"
            :pagination-options="{
                enabled: true,
                perPage: 10,
                nextLabel: 'Próximo',
                prevLabel: 'Anterior',
                rowsPerPageLabel: 'Resultados por página',
                ofLabel: 'de',
                pageLabel: 'página',
                allLabel: 'Todos'
            }"
            styleClass="vgt-table striped"
        >
            <div slot="emptystate">
                <div class="text-center">
                    <p>Nenhum sindicato foi registrado.</p>
                </div>
            </div>
            <template slot="table-row" slot-scope="props">
                <div
                    v-if="props.column.field === 'acoes'"
                    class="flex flex-col"
                >
                    <div
                        class="h-6 mb-2"
                        title="Visualizar Sindicato"
                        @click.prevent="
                            () =>
                                $router.push(
                                    '/sistema/sindicatos/editar-sindicato/' +
                                        props.row.id
                                )
                        "
                    >
                        <svg-icon
                            icon="search-light"
                            class="cursor-pointer text-primary"
                        ></svg-icon>
                    </div>
                </div>
            </template>
        </vue-good-table>
    </div>
</template>

<script>
import { VueGoodTable } from "vue-good-table";
import JsonCSV from "vue-json-csv";
export default {
    name: "tabela-sindicatos-evento",

    components: { VueGoodTable, downloadCsv: JsonCSV },

    created() {
        this.getSindicatosEvento();
    },

    data() {
        return {
            sindicatosLista: [],
            sindicatos: {
                columns: [
                    { label: "Nome", field: "nome_fantasia" },
                    { label: "Presidente", field: "nome_presidente" },
                    { label: "Telefone", field: "telefone" },
                    { label: "Whatsapp", field: "whatsapp" },
                    { label: "Email", field: "email" },
                    { label: "Cidade", field: "cidade" },
                    { label: "Ações", field: "acoes" }
                ],
                rows: [],
                total: 0,
                filtros: {
                    field: "id",
                    type: "desc"
                },
                page: 1,
                perPage: 10
            }
        };
    },

    methods: {
        /**
         * Altera a paginação
         * @param params
         */
        onPageChange(params) {
            this.sindicatos.page = params.currentPage;
            this.filtrarSindicatos({ page: params.currentPage });
        },

        /**
         * Filtra pela coluna conforme ascendente/descendente
         * @param params
         */
        onSortChange(params) {
            this.filtrarSindicatos({
                sort: {
                    type: params[0].type,
                    field: params[0].field
                }
            });
        },

        /**
         * Altera a quantidade de registros por página
         * @param params
         */
        onPerPageChange(params) {
            this.sindicatos.perPage = params.currentPerPage;
            this.getSindicatosEvento();
            // this.filtrarSindicatos({ perPage: params.currentPerPage });
        },

        /**
         * Filtra os eventos conforme as mudanças
         * @param newProps
         */
        filtrarSindicatos(newProps) {
            this.sindicatos.filtros = Object.assign(
                {},
                this.sindicatos.filtros,
                newProps
            );
            this.getSindicatosEvento();
        },

        getSindicatosEvento() {
            this.axios("/participantes-evento/" + this.$route.params.id, {
                params: {
                    page: this.sindicatos.page,
                    per_page: this.sindicatos.perPage
                }
            })
                .then(response => {
                    if (response.status === 200) {
                        this.sindicatos.rows = response.data.sindicatos.data;
                        this.sindicatos.total = response.data.sindicatos.total;
                        this.getSindicatosListaEvento();
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        },

        getSindicatosListaEvento() {
            this.axios("/participantes-lista-evento/" + this.$route.params.id)
                .then(response => {
                    this.sindicatosLista = response.data.sindicatos;
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }
};
</script>

<style scoped lang="scss">
.icon-excel {
    @apply w-6 h-6;
}
</style>
